import { TagKey } from './constants';
import { generatedGspApi } from './gsp.generated';

const gspApi = generatedGspApi.enhanceEndpoints({
  addTagTypes: [
    TagKey.AdminSchoolLinks,
    TagKey.SchoolLinks,
    TagKey.TranslationTokens,
    TagKey.UserSettings,
  ],
  endpoints: {
    getApiLocalesByLocaleId: {
      providesTags: [TagKey.TranslationTokens],
    },
    getApiUserSettings: {
      providesTags: [TagKey.UserSettings],
    },
    postApiUserSettings: {
      invalidatesTags: (_, error) =>
        error ? [] : [TagKey.TranslationTokens, TagKey.UserSettings],
    },
    getApiAdminSchoolLinksManagerSearch: {
      providesTags: [TagKey.AdminSchoolLinks],
    },
    getApiSchoolLinks: {
      providesTags: [TagKey.SchoolLinks],
    },
    postApiAdminSchoolLinksManagerLink: {
      invalidatesTags: (_, error) =>
        error ? [] : [TagKey.AdminSchoolLinks, TagKey.SchoolLinks],
    },
    deleteApiAdminSchoolLinksManagerLinkBySchoolLinkId: {
      invalidatesTags: (_, error) =>
        error ? [] : [TagKey.AdminSchoolLinks, TagKey.SchoolLinks],
    },
    putApiAdminSchoolLinksManagerLinkBySchoolLinkId: {
      invalidatesTags: (_, error) =>
        error ? [] : [TagKey.AdminSchoolLinks, TagKey.SchoolLinks],
    },
    getApiSchoolLinksBySchoolLinkIdDownload: {
      query: queryArg => ({
        url: `/api/school-links/${queryArg.schoolLinkId}/download`,
        responseHandler: res => res.blob(),
      }),
    },
    postApiAdminByStudentIdMasquerade: {
      invalidatesTags: [TagKey.SchoolLinks],
    },
    postApiAdminClearMasquerading: {
      invalidatesTags: [TagKey.SchoolLinks],
    },
  },
});

export const {
  useGetApiAccountMeQuery,
  useLazyGetApiAccountMeQuery,
  useGetApiDashboardByStudentIdQuery,
  useLazyGetApiDashboardByStudentIdQuery,
  useGetApiSchoolSettingsQuery,
  useLazyGetApiSchoolSettingsQuery,
  useGetApiSubjectsByStudentIdQuery,
  useLazyGetApiSubjectsByStudentIdQuery,
  useGetApiSubjectsByStudentIdAndSubjectIdOverviewQuery,
  useLazyGetApiSubjectsByStudentIdAndSubjectIdOverviewQuery,
  useGetApiSubjectsByStudentIdAndSubjectIdAssignmentsQuery,
  useLazyGetApiSubjectsByStudentIdAndSubjectIdAssignmentsQuery,
  useGetApiSubjectsByStudentIdAndSubjectIdAssignmentsAssignmentIdQuery,
  useLazyGetApiSubjectsByStudentIdAndSubjectIdAssignmentsAssignmentIdQuery,
  useGetApiProgressByStudentIdQuery,
  useLazyGetApiProgressByStudentIdQuery,
  useGetApiProgressByStudentIdAndSubjectIdQuery,
  useLazyGetApiProgressByStudentIdAndSubjectIdQuery,
  useGetApiSubjectsByStudentIdAndSubjectIdResourcesQuery,
  useLazyGetApiSubjectsByStudentIdAndSubjectIdResourcesQuery,
  useGetApiAdminStudentSearchQuery,
  useLazyGetApiAdminStudentSearchQuery,
  useGetApiTimetableStudentByStudentIdQuery,
  useLazyGetApiTimetableStudentByStudentIdQuery,
  useGetApiDashboardByStudentIdUpcomingAssignmentsQuery,
  useLazyGetApiDashboardByStudentIdUpcomingAssignmentsQuery,
  usePostApiAdminByStudentIdMasqueradeMutation,
  usePostApiAdminClearMasqueradingMutation,
  useGetApiTimetableStudentByStudentIdAndSubjectIdOverviewQuery,
  useLazyGetApiTimetableStudentByStudentIdAndSubjectIdOverviewQuery,
  useLazyGetApiAdminSchoolLinksManagerSearchQuery,
  useGetApiSchoolLinksQuery,
  useLazyGetApiSchoolLinksQuery,
  usePostApiParentHelperFeedbackByMessageIdMutation,
  usePostApiAdminSchoolLinksManagerLinkMutation,
  usePutApiAdminSchoolLinksManagerLinkBySchoolLinkIdMutation,
  useDeleteApiAdminSchoolLinksManagerLinkBySchoolLinkIdMutation,
  useGetApiSchoolLinksBySchoolLinkIdDownloadQuery,
  useLazyGetApiSchoolLinksBySchoolLinkIdDownloadQuery,
  usePostApiParentHelperAskQuestionMutation,
  useLazyGetApiParentHelperChatsLatestQuery,
  useLazyGetApiParentHelperChatsByChatIdQuery,
  useLazyGetApiParentHelperTopicsQuery,
  useGetApiSubjectsByStudentIdAndSubjectIdSyllabusQuery,
  useLazyGetApiSubjectsByStudentIdAndSubjectIdSyllabusQuery,
  useDeleteApiParentHelperChatsByChatIdMutation,
  usePutApiParentHelperTopicsFavouriteMutation,
  useGetApiLocalesByLocaleIdQuery,
  useLazyGetApiLocalesByLocaleIdQuery,
  useGetApiUserSettingsQuery,
  useLazyGetApiUserSettingsQuery,
  usePostApiUserSettingsMutation,
} = gspApi;

export { gspApi };
